// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".insurance_refunds__teaser_3[data-v-5ea48414] a,.insurance_refunds__teaser_3[data-v-5ea48414] p,.insurance_refunds__teaser_3[data-v-5ea48414] strong{color:#090909}", ""]);
// Exports
module.exports = exports;
